import type { CatalogClientDto } from '../dto';
import type { CatalogClient } from '../models';

export const mapCatalogClientDtoToModel = (
  dto: CatalogClientDto,
): CatalogClient => ({ ...dto });

export const mapCatalogClientsListDtoToModel = (
  dto: CatalogClientDto[],
): CatalogClient[] => dto.map(mapCatalogClientDtoToModel);
